import * as React from 'react';

export function OrderBagIcon({ title }: Props): React.ReactElement {
    return (
        <svg width='41' height='40' viewBox='0 0 41 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
            {title && <title>{title}</title>}
            <circle cx='20.333' cy='20' r='20' fill='#E5DAFB' />
            <g clipPath='url(#clip0_1415_293)'>
                <path
                    d='M18.333 15.5C18.333 14.3969 19.2299 13.5 20.333 13.5C21.4361 13.5 22.333 14.3969 22.333 15.5V17H18.333V15.5ZM16.833 17H14.833C14.0049 17 13.333 17.6719 13.333 18.5V25C13.333 26.6562 14.6768 28 16.333 28H24.333C25.9893 28 27.333 26.6562 27.333 25V18.5C27.333 17.6719 26.6611 17 25.833 17H23.833V15.5C23.833 13.5656 22.2674 12 20.333 12C18.3986 12 16.833 13.5656 16.833 15.5V17ZM17.583 18.5C17.7819 18.5 17.9727 18.579 18.1133 18.7197C18.254 18.8603 18.333 19.0511 18.333 19.25C18.333 19.4489 18.254 19.6397 18.1133 19.7803C17.9727 19.921 17.7819 20 17.583 20C17.3841 20 17.1933 19.921 17.0527 19.7803C16.912 19.6397 16.833 19.4489 16.833 19.25C16.833 19.0511 16.912 18.8603 17.0527 18.7197C17.1933 18.579 17.3841 18.5 17.583 18.5ZM22.333 19.25C22.333 19.0511 22.412 18.8603 22.5527 18.7197C22.6933 18.579 22.8841 18.5 23.083 18.5C23.2819 18.5 23.4727 18.579 23.6133 18.7197C23.754 18.8603 23.833 19.0511 23.833 19.25C23.833 19.4489 23.754 19.6397 23.6133 19.7803C23.4727 19.921 23.2819 20 23.083 20C22.8841 20 22.6933 19.921 22.5527 19.7803C22.412 19.6397 22.333 19.4489 22.333 19.25Z'
                    fill='#7F46F8'
                />
            </g>
            <defs>
                <clipPath id='clip0_1415_293'>
                    <rect width='14' height='16' fill='white' transform='translate(13.333 12)' />
                </clipPath>
            </defs>
        </svg>
    );
}

type Props = {
    title?: string;
};
